import { useMemo, useState } from 'react';

import { Button, List, Typography } from 'antd';

import {
    faBarcode,
    faChevronDown,
    faChevronUp,
    faHammer,
    faPlus,
    faScrewdriverWrench,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './style.scss';

interface IProps {
    data: Array<{
        id: number;
        name: string;
        quantity: number;
        type: 'product' | 'service' | 'task';
        usage_percent: number;
    }>;
}

export const RelatedEntitiesList: React.FC<IProps> = ({ data = [] }) => {
    const [listOpen, setListOpen] = useState<boolean>(false);

    const icons = useMemo(
        () => ({
            service: faScrewdriverWrench,
            product: faBarcode,
            task: faHammer,
        }),
        []
    );

    return (
        <div className="related-entities__wrapper">
            <div className="related-entities__header">
                <div className="header-description">
                    <Typography.Title level={5} className="related-entities__title">
                        Сопутствующие услуги, товары, задачи
                        <Typography.Text className="related-entities__count">
                            &nbsp;{data.length}
                        </Typography.Text>
                    </Typography.Title>
                </div>
                <div className="header-button" onClick={() => setListOpen(!listOpen)}>
                    <FontAwesomeIcon icon={listOpen ? faChevronDown : faChevronUp} size="xl" />
                </div>
            </div>
            <List
                className="related-entities__list"
                style={{ height: listOpen ? '165px' : 0 }}
                dataSource={data}
                renderItem={(item) => {
                    return (
                        <List.Item className="related-entities__item">
                            <div style={{ width: '5%' }}>
                                <FontAwesomeIcon icon={icons[item.type]} color="orange" />
                            </div>
                            <Typography.Text
                                className="item-name"
                                style={{
                                    width: '65%',
                                }}
                            >
                                {item.name}
                            </Typography.Text>
                            <div className="item-right-section" style={{ width: '30%' }}>
                                <Typography.Text>
                                    {item.quantity} шт. {item.usage_percent}%
                                </Typography.Text>
                                <Button
                                    className="item-add-btn"
                                    shape="circle"
                                    icon={<FontAwesomeIcon icon={faPlus} color="blue" />}
                                />
                            </div>
                        </List.Item>
                    );
                }}
            />
        </div>
    );
};
